import React from "react"
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {KensuObjectEditor} from "../../../../components/table/KensuObjectEditor";
import {
  IApiBusinessProto,
  space,
  UpdateBusinessSettingsRequest,
  UpdatedBusinessResponse
} from "../../../../provider_api";
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import {EditableYesNo} from "../../../../components/Editable/EditableYesNo";
import BusinessSettingsProto = space.kenko.proto.BusinessSettingsProto;
import IBusinessSettingsProto = space.kenko.proto.IBusinessSettingsProto;
import BusinessSubscriptionType = space.kenko.proto.BusinessSubscriptionType;
import {useSettingsTabs} from "./SettingsRouter";
import {getSubscriptionType} from "../../../../util/SubscriptionUtil";

export const Settings = () => {

  const {business, setBusiness} = useProviderProfile();

  return <>

    <TabbedPageHeader pageTitle={'Settings'}
                      tabs={useSettingsTabs()}/>

    <KensuObjectEditor<IBusinessSettingsProto, IApiBusinessProto>
        idParam={'singleton'} // singleton, doesn't make sense.
        entityName={'Business Profile'}
        hideHeaderInEditMode={true}
        entityListViewLink={'/profile'}
        getter={() => business?.businessSettings ?? new BusinessSettingsProto()}
        handleContainerTypeUpdate={setBusiness}
        getTitle={() => 'Business Settings'}
        newBlankType={() => new BusinessSettingsProto()}
        getRpcMethod={_ => 'update_business_settings'}
        getRpcPayload={business => UpdateBusinessSettingsRequest.encode(
            new UpdateBusinessSettingsRequest({
              settings: business
            })).finish()}
        parseRpcResponse={UpdatedBusinessResponse.decode}>

      {getSubscriptionType(business) == BusinessSubscriptionType.LISTING_PLUS_BOOKING && <>

        <EditableYesNo<IBusinessSettingsProto>
            field={'offersClasses'}
            getter={entity => entity.offersClasses}
            setter={(entity, value) => ({...entity, offersClasses: value})}
            label={'Offers classes'}
            helpText={'Select Yes if your business offers public classes. For public classes, ' +
                'list your offered classes in the Catalog then set your class schedule ' +
                'in the Calendar.'}
        />

        <br/>

        <EditableYesNo<IBusinessSettingsProto>
            field={'offersAppointments'}
            getter={entity => entity.offersAppointments}
            setter={(entity, value) => ({...entity, offersAppointments: value})}
            label={'Offers appointments'}
            helpText={'Select this if your business offers privately scheduled appointments. ' +
                'For appointments, list your available services via the Catalog and configure ' +
                'your availability in the Calendar.'}
        />

        <EditableYesNo<IBusinessSettingsProto>
            field={'offersInPersonServices'}
            getter={entity => entity.offersInPersonServices}
            setter={(entity, value) => ({...entity, offersInPersonServices: value})}
            label={'Offers in-person services'}
        />
        
        <EditableYesNo<IBusinessSettingsProto>
            field={'offersVirtualServices'}
            getter={entity => entity.offersVirtualServices}
            setter={(entity, value) => ({...entity, offersVirtualServices: value})}
            label={'Offers virtual services'}
        />
      </>}

      <br/>

      <EditableYesNo<IBusinessSettingsProto>
          field={'newClientsMustInquire'}
          getter={entity => entity.newClientsMustInquire}
          setter={(entity, value) => ({...entity, newClientsMustInquire: value})}
          label={'New clients must inquire'}
          helpText={`Select this if you require your clients to inquire about your business ` +
              `before booking their first class or appointment. You'll receive an email ` +
              `notification each time a prospective client inquires.`}
      />

    </KensuObjectEditor>
  </>
    
}